import IconBase from './IconBase'
import { ReactComponent } from './light/ellipsis-v.svg'

const EllipsisVerticalIcon = (props: any) => <IconBase {...props} ReactComponent={ReactComponent} />

export default EllipsisVerticalIcon
